// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file medical_master/accept_pricing_all.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.AcceptPricingAllRequest
 */
export class AcceptPricingAllRequest extends Message<AcceptPricingAllRequest> {
  constructor(data?: PartialMessage<AcceptPricingAllRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AcceptPricingAllRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AcceptPricingAllRequest {
    return new AcceptPricingAllRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AcceptPricingAllRequest {
    return new AcceptPricingAllRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AcceptPricingAllRequest {
    return new AcceptPricingAllRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AcceptPricingAllRequest | PlainMessage<AcceptPricingAllRequest> | undefined, b: AcceptPricingAllRequest | PlainMessage<AcceptPricingAllRequest> | undefined): boolean {
    return proto3.util.equals(AcceptPricingAllRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.AcceptPricingAllResponse
 */
export class AcceptPricingAllResponse extends Message<AcceptPricingAllResponse> {
  constructor(data?: PartialMessage<AcceptPricingAllResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.AcceptPricingAllResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AcceptPricingAllResponse {
    return new AcceptPricingAllResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AcceptPricingAllResponse {
    return new AcceptPricingAllResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AcceptPricingAllResponse {
    return new AcceptPricingAllResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AcceptPricingAllResponse | PlainMessage<AcceptPricingAllResponse> | undefined, b: AcceptPricingAllResponse | PlainMessage<AcceptPricingAllResponse> | undefined): boolean {
    return proto3.util.equals(AcceptPricingAllResponse, a, b);
  }
}

